import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {HomeComponent} from '../app/dashboard/home/home.component';
import {HomeLogoutComponent} from '../app/dashboard/home/home.logout.component';
import {MainComponent} from '../app/dashboard/main/main.component';
import {AppComponent} from 'src/app/app.component';
import {AuthService} from 'src/app/utility/auth/auth.service';
import {MemberLayoutComponent} from 'src/app/setting/member/layout/layout.component';
import {SignInComponent} from 'src/app/member/signin/signin.component';
import {SignUpComponent} from 'src/app/member/signup/signup.component';
import {environment} from 'src/environments/environment';
import {ChangePasswordComponent} from 'src/app/member/change-password/change.password.component';
import {TokenListComponent} from '@serengeti/serengeti-token';
import {AuthGuardService} from 'src/app/auth-guard.service';
import {UserDetailComponent} from "@serengeti/serengeti-user";
import {SsoComponent} from "../app/member/signin/sso/sso.component";
import { DpgSignUpComponent } from '@serengeti/serengeti-login';

const routes: Routes = [

	{ path: '', redirectTo: 'home', pathMatch: 'full' },
	{ path: 'main', component: AppComponent, canActivate: [AuthService], children: [
		{ path: '', component: MainComponent, outlet: 'content', data: { title: 'home.dashboard.title', root: true } },
		{ path: 'dashboard', component: MainComponent, outlet: 'content', data: { title: 'home.dashboard.title', root: true } },
		{ path: 'user/:id', component: UserDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'setting.user.detail.title', root: true } },
		{ path: 'token', component: TokenListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'home.menu.token', root: true } },
	]},

	{ path: 'signin', component: SignInComponent, canActivate: [AuthGuardService] },
  	{ path: 'ssosignin', component: SsoComponent },
	{ path: 'signup', component: SignUpComponent },
	{ path: 'dpgSignup', component: DpgSignUpComponent },
	{ path: 'change-password', component: ChangePasswordComponent },

	{ path: 'activate', component: HomeComponent },
	{ path: 'home', component: HomeComponent, data: { title: 'home.title.' + environment.profile, root: true }} ,

	{ path: 'member', component: MemberLayoutComponent, children: [
		{ path: 'login', component: HomeLogoutComponent },
		{ path: 'logout', component: HomeLogoutComponent }
	]},

];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule],
	providers: [AuthGuardService]
})
export class AppRoutingModule { }
